import { CaretUpFilled, UpCircleOutlined, UpOutlined } from '@ant-design/icons';
import React, {useState} from 'react';
  
const ScrollButton = () =>{
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
<button style={{display: visible ? 'inline' : 'none'}} onClick={scrollToTop}  >
  <div className='w-[60px] h-[60px] bg-[#00acd4] rounded-full  flex p-2'>
    <div className='bg-white rounded-full w-full h-full items-center justify-center flex'>

 
  <CaretUpFilled style={{color:"#00acd4", fontSize:18}} />
  </div>
  </div>
    
   </button>
  );
}
  
export default ScrollButton;